import { render, staticRenderFns } from "./default.vue?vue&type=template&id=99c3b90e&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PreviewBanner: require('/usr/src/motec/components/PreviewBanner.vue').default,TheHeader: require('/usr/src/motec/components/TheHeader.vue').default,TheFooter: require('/usr/src/motec/components/TheFooter.vue').default})
